import {ContractInformationResponseBodyV2} from '@dms/api/customer';

import {getNaturalPersonFullName} from './getNaturalPersonFullName';
import {isContractNaturalPerson} from './isContractNaturalPerson';

export const getContractTitle = (contract: ContractInformationResponseBodyV2) =>
  isContractNaturalPerson(contract)
    ? getNaturalPersonFullName(contract.person)
    : contract.businessInfo?.businessInfo?.tradeName;
